import { render } from "./SpecialOrderList.vue?vue&type=template&id=1b1d180c&scoped=true"
import script from "./SpecialOrderList.vue?vue&type=script&lang=js"
export * from "./SpecialOrderList.vue?vue&type=script&lang=js"

import "./SpecialOrderList.vue?vue&type=style&index=0&id=1b1d180c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1d180c"]])

export default __exports__